import {Image, Link} from '@shopify/hydrogen';
import edition from '../assets/image/edition.svg';
import editorial from '../assets/image/editorial.svg';
import formato from '../assets/image/icons/icon-formato.svg';
import age from '../assets/image/age.svg';
import pages from '../assets/image/pages.svg';
import published from '../assets/image/published.svg';
import 'react-loading-skeleton/dist/skeleton.css';
import { encriptUrlData, isMobile } from '../lib/Utils';


export default function ProductDetailsInfo({sanityData, product}) {

  return (
    <div className="p-5 xs:pt-0 xs:px-0">
      {
        product?.pages?.value ||
        product?.launch_date?.value ||
        product?.titles?.value ||
        product?.brand?.value ||
        product?.no_of_pages?.value ||
        product?.age_group?.value ||
        product?.format?.value ||
        product?.height?.value ||
        product?.width?.value ||
        product?.weight?.value
      ? (
        <>
          
          {/* {sanityData?.bookExcerptUrl && isMobile() && (
          <div className="mt-3 w-full excerpt-container">
              <Link
                to={'/producto/fragment?f='+encriptUrlData(sanityData?.bookExcerptUrl)}
                className="read-excerpt-button read-excerpt-button-phone"
                target='blank'
              >
                <span>Leer fragmento</span>
                <img src={excerptButton} />
              </Link>
          </div>
          )} */}

          <h2 className="product-title mb-6 product-title-append">Detalles del libro</h2>
          <div className="detalles-libro xs:flex xs:flex-wrap">
            {product?.no_of_pages?.value && (
              <div className="detalles-item flex flex-wrap mb-4 xs:w-1/2 relative">
                <div className="detalles-icon">
                  <Image
                    src={pages}
                    height={20}
                    width={20}
                    alt="number of pages"
                  />
                </div>
                <div className="detalles-text">
                  <p className="font-semibold text-sm">No. de páginas</p>
                  <span> {product?.no_of_pages?.value} </span>
                </div>
              </div>
            )}
            
            {/* {(product?.height?.value || product?.width?.value || product?.weight?.value)
            && (
              <div className="detalles-item flex flex-wrap mb-4 xs:w-1/2 relative">
                <div className="detalles-icon">
                  <Image
                    src={measurement}
                    height={20}
                    width={20}
                    alt="measurement"
                  />
                </div>
                <div className="detalles-text">
                  <p className="font-semibold text-sm">Medidas</p>
                  <span> W {product?.width?.value} </span>
                  <span> H {product?.height?.value} </span>
                  <span> G {product?.weight?.value} </span>
                </div>
              </div>
            )} */}

            {product?.launch_date?.value? (
              <div className="detalles-item flex flex-wrap mb-4 xs:w-1/2 relative">
                <div className="detalles-icon">
                  <Image
                    src={published}
                    height={20}
                    width={20}
                    alt="date of publication"
                  />
                </div>
                <div className="detalles-text">
                  <p className="font-semibold text-sm">Año de publicación</p>
                  <span> {product?.launch_date?.value} </span>
                </div>
              </div>
            ) : (
              ''
            )}
            {product?.titles?.value ? (
              <div className="detalles-item flex flex-wrap mb-4 xs:w-1/2 relative">
                <div className="detalles-icon">
                  <Image src={edition} height={20} width={20} alt="edition" />
                </div>
                <div className="detalles-text">
                  <p className="font-semibold text-sm">Edición</p>
                  <span> {product?.titles?.value} </span>
                </div>
              </div>
            ) : (
              ''
            )}
            {product?.brand?.value && (
              <div className="detalles-item flex flex-wrap mb-4 xs:w-1/2 relative">
                <div className="detalles-icon">
                  <Image
                    src={editorial}
                    height={20}
                    width={20}
                    alt="editorial"
                  />
                </div>
                <div className="detalles-text">
                  <p className="font-semibold text-sm">Editorial</p>
                  <span> {product?.brand?.value}</span>
                </div>
              </div>
            )}
            {product?.age_group?.value && (
              <div className="detalles-item flex flex-wrap mb-4 xs:w-1/2 relative">
                <div className="detalles-icon">
                  <Image src={age} height={20} width={20} alt="age group" />
                </div>
                <div className="detalles-text">
                  <p className="font-semibold text-sm">Edad sugerida</p>
                  <span> {product?.age_group?.value} </span>
                </div>
              </div>
            )}
            {product?.format?.value && (
              <div className="detalles-item flex flex-wrap mb-4 xs:w-1/2 relative">
                <div className="detalles-icon">
                  <Image src={formato} height={20} width={20} alt="formato" />
                </div>
                <div className="detalles-text">
                  <p className="font-semibold text-sm">Formato</p>
                  <span> {product?.format?.value} </span>
                </div>
              </div>
            )}
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
}
